import React from "react";
import PropTypes from 'prop-types';
import collapse from './collapse.svg'
import camera from './camera.svg'
import styles from './feature-description.module.css'
import panelButtonStyles from '../panel-button/panel-button.module.css'

export default function FeatureDescription({ visible, feature, layerLabel, onHideButtonClick, onFocusElementClick }) {
    return (<>
            <div className={`${styles.featureDescriptionContainer} ${!visible ? styles.collapsed : ''}`}>
                <div className={styles.featureDescriptionHeader}>
                    <div className={panelButtonStyles.panelButton} onClick={() => onFocusElementClick()}>
                        <img src={camera} />
                    </div>
                    <div className={styles.featureDescriptionLabel}>{layerLabel}</div>
                    <div className={panelButtonStyles.panelButton} onClick={() => onHideButtonClick()}>
                        <img style={{ transform: "rotate(-90deg)" }} src={collapse} />
                    </div>
                </div>
                {feature &&
                    <div className={styles.featureDescription}>
                        <table>
                            <tbody>
                                {Object.keys(feature).map(key =>
                                (
                                    <tr key={key}>
                                        <th>{key}</th>
                                        <td>{feature[key]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
    </>);
}

FeatureDescription.propTypes = {
    visible: PropTypes.bool.isRequired,
    feature: PropTypes.object,
    layerLabel: PropTypes.string,
    onHideButtonClick: PropTypes.func.isRequired,
    onFocusElementClick: PropTypes.func.isRequired
};